"use client";
import { jsxs as v, jsx as n } from "react/jsx-runtime";
import { ellipsis as x } from "../../common/styles/mixins/ellipsis.js";
import { focusOutline as L } from "../../common/styles/mixins/focusOutline.js";
import S from "../icon/Icon.js";
import { css as y } from "@emotion/react";
import m from "@emotion/styled";
import { COLORS as t } from "../../tokens/colors/Colors.js";
import { FONT_WEIGHTS as w } from "../../tokens/font-weights/FontWeights.js";
import { SPACINGS as p } from "../../tokens/spacings/Spacings.js";
import { forwardRef as O } from "react";
const f = O(
  ({ children: o, feColor: i = "primary", feIcon: r, onClick: e, ...a }, h) => {
    const { as: l } = a, b = l === "a" ? a.href : void 0, c = l === "button" ? a.route : void 0, $ = (s, g) => {
      l === "a" && e && s.preventDefault(), e == null || e(s, g);
    };
    return /* @__PURE__ */ v(
      k,
      {
        ...a,
        as: l,
        "data-comp": "link",
        feColor: i,
        onClick: (s) => $(s, b ?? c ?? ""),
        ref: h,
        children: [
          (r == null ? void 0 : r.position) === "left" && /* @__PURE__ */ n(u, { ...r }),
          /* @__PURE__ */ n(j, { children: o }),
          (r == null ? void 0 : r.position) === "right" && /* @__PURE__ */ n(u, { ...r })
        ]
      }
    );
  }
);
f.displayName = "Link";
const F = f, d = Object.freeze({
  primary: {
    default: t.brand,
    disabled: t.gray500,
    hover: t.primary800
  },
  secondary: {
    default: t.white,
    disabled: t.primary500,
    hover: t.primary200
  },
  tertiary: {
    default: t.gray700,
    disabled: t.gray500,
    hover: t.black
  }
}), k = m.span(
  ({ as: o, feColor: i, feStretch: r }) => {
    if (!i)
      throw new Error("Style error");
    return y`
			align-items: center;
			color: ${d[i].default};
			display: ${r ? "flex" : "inline-flex"};
			font-weight: ${w.bold};
			text-decoration: none;
			width: ${r && o === "button" && "100%"};

			&:focus-visible {
				${L({ color: d[i].default })}
			}

			&:hover {
				color: ${d[i].hover};
			}

			/* Will only be applied on the button-element */
			&:disabled {
				color: ${d[i].disabled};
			}
		`;
  }
), u = m(S)(
  ({ position: o }) => y`
		color: inherit;
		margin-left: ${o === "right" && p.xs};
		margin-right: ${o === "left" && p.xs};
	`
), j = m.span`
	${x()}
`;
export {
  F as default
};
